import { getEnvVar } from '../../utils/env';

const VALIDATION_STORAGE = {
  CONTROLS: {},
  AUTOCOMPLETE_ERRORS_CACHE: {},
};

if (['development', 'test'].includes(process.env.NODE_ENV)) {
  // to get quick access through the console
  // and for testing
  window.VALIDATION_STORAGE = VALIDATION_STORAGE;
}

export const getControls = () => VALIDATION_STORAGE.CONTROLS;

export const getAutoCompleteErrorsCache = () => VALIDATION_STORAGE.AUTOCOMPLETE_ERRORS_CACHE;

export const setAutoCompleteErrorsCache = (rowId, textBoxId, value) => {
  const cache = getAutoCompleteErrorsCache();

  if (!cache[rowId]) {
    cache[rowId] = {};
  }

  cache[rowId][textBoxId] = value;
};

export const bindControl = (instanceId, props) => {
  const controls = getControls();
  controls[instanceId] = props;
};

export const releaseControl = (instanceId) => {
  const controls = getControls();
  delete controls[instanceId];
};

export const clearValidationStorage = () => {
  if (getEnvVar('REACT_APP_DEBUG')) {
    // eslint-disable-next-line no-console
    console.log('🧹 Clear Validation Storage');
  }

  Object.keys(VALIDATION_STORAGE).forEach((key) => {
    VALIDATION_STORAGE[key] = {};
  });
};
